import { $axios } from "../../config/axios";
import PondGuard from "../../model/pondguard";
import moment from "moment";

const state = {
  pondGuards: [],
  pondGuardSensorData: [],
};
const getters = {
  getPondGuards: (state) => state.pondGuards,
  getPgIdPGObj: (state) => {
    const pgIdPgObj = {};
    state.pondGuards.forEach((pg) => {
      pgIdPgObj[pg._id] = pg;
    });
    return pgIdPgObj;
  },
  getPgIdPGSensorData: (state) => {
    const pgIdPgObj = {};
    state.pondGuardSensorData.forEach((pg) => {
      pgIdPgObj[pg._id] = pg;
    });
    return pgIdPgObj;
  },
};
const mutations = {
  SET_POND_GUARD_DETAILS(state, pondGuardData) {
    if (pondGuardData != null) {
      const pgArr = [];
      pondGuardData.forEach((pondguard) => {
        const pgObj = new PondGuard();
        pgObj.castToPGObj(pondguard);
        pgArr.push(pgObj);
      });
      state.pondGuards = pgArr;
    } else {
      state.pondGuards = null;
    }
  },
  SET_POND_GUARD_SENSOR_DATA(state, pondGuardData) {
    if (pondGuardData != null) {
      const pgArr = [];
      pondGuardData.forEach((pondguard) => {
        const pgObj = new PondGuard();
        pgObj.castToPGObj(pondguard);
        pgArr.push(pgObj);
      });
      state.pondGuardSensorData = pgArr;
    } else {
      state.pondGuardSensorData = null;
    }
  },
};
const actions = {
  fetchAllPondGuards: function(context, queryParams) {
    return new Promise((resolve, reject) => {
      $axios
        .get("/ponds/pond-guards", {
          params: queryParams,
        })
        .then((response) => {
          context.commit("SET_POND_GUARD_DETAILS", response.data.pond_guards);
          resolve({
            message: response.data.message,
            totalPGs: response.data.total,
            page: response.data.page,
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchPondGuardData: function(context, { pondGuardId, params }) {
    return new Promise((resolve, reject) => {
      $axios
        .get(`/ponds/pond-guards/${pondGuardId}/sensor-data`, { params })
        .then((response) => {
          context.commit("SET_POND_GUARD_DETAILS", response.data.pond_guards);
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  savePondGuardData: function(context, { pondguardcode }) {
    return new Promise((resolve, reject) => {
      const promiseArr = [];
      for (let i = 0; i < 1000; i++) {
        let date = moment().add(i, "hours");
        const diffe = date.diff(moment(), "days");
        if (diffe > 0) {
          date = date.subtract(diffe, "days");
        }
        promiseArr.push(
          $axios.get(
            `/devices/pond-guards/sensor-data?id=${pondguardcode}&dt=${date.format(
              "DDMMYY"
            )}&tm=${date.format("HHmmss")}&tp=${Math.random() *
              27}&ox=${Math.random() * 10}&ph=${Math.random() *
              14}&bv=${Math.random() * 10}&lv=${Math.random() *
              10}&at=${Math.random() * 2}&ap=${Math.random() * 100}&status=1`
          )
        );
      }
      Promise.all(promiseArr).then((response) => {});
    });
  },
  fetchAPondGuard: function(context, pondGuardId) {
    return new Promise((resolve, reject) => {
      $axios
        .get("/ponds/pond-guards/" + pondGuardId)
        .then((response) => {
          // context.commit('SET_POND_MOTHER_DATA',response.data.pondGuard)
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addPondGuardDetails: function(context, pondGuard) {
    return new Promise((resolve, reject) => {
      $axios
        .post("/ponds/pond-guards", pondGuard)
        .then((response) => {
          // context.commit('SET_POND_MOTHER_DATA',response.data.pondGuard)
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateArrPondGuardDetails: function(context, payload) {
    return new Promise((resolve, reject) => {
      // console.log(pondMotherId)
      $axios
        .patch(`/ponds/pond-guards/settings`, payload)
        .then((response) => {
          // context.commit('SET_POND_MOTHER_DATA',response.data.pondGuard)
          // console.log(response.data);
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  unAssignPondGuard: function(context, pondguard) {
    return new Promise((resolve, reject) => {
      // console.log(pondguard);
      $axios
        .delete(`/ponds/pond-guards/${pondguard}`)
        .then((response) => {
          // context.commit('SET_POND_MOTHER_DATA',response.data.pondgsuard)
          // console.log(response.data);
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
